module.exports = __webpack_public_path__ + "cef3832015f6f69d4ec258dfe6577657.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-24.png
// module id = 1979
// module chunks = 0